// colors.js

export const gradientColors = {
    primaryStart: '#2196F3', // Start color of the gradient (blue)
    primaryEnd: '#21CBF3',   // End color of the gradient (light blue)
    contrastText: '#ffffff', // White text for better contrast on gradients
    disabledBackground: '#cfcfcf', // Greyed out background for disabled state
    disabledText: '#a1a1a1', // Slightly darker text for disabled state
  };
  